import React from "react";
import BreadCrumb from "common/breadcrumb";
import GalleryContent from "./gallery-content";
import OverlayContent from "./overlay-content";
import GalleryAnimation from "./gallery-animation";
import GalleryWithCard from "./gallery-with-card";
import GridGallery from "./grid-gallery";

const UiGallery = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title="Gallery" pageTitle="UI Elements" />
                <div>
                    <GalleryContent />
                    <OverlayContent />
                    <GalleryAnimation />
                    <GalleryWithCard />
                    <GridGallery />
                </div>
            </div>
        </React.Fragment>
    );
}

export default UiGallery;